// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-snack__wrapper {\n  min-width: 100px !important;\n  height: 40px !important;\n}\nhtml {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: inherit;\n          box-sizing: inherit;\n}\n#app {\n  text-align: center;\n}\nbody {\n  font-family: sans-serif;\n  padding: 0;\n  margin: 0;\n}\nlabel {\n  padding: 10px 0;\n  display: inline-block;\n}\n.timer {\n  font-size: 2em;\n  margin: 20px;\n}", ""]);
// Exports
module.exports = exports;
